module.exports = __webpack_public_path__ + "img/error.25a84e38.svg";